export enum LOCAL_STORAGE_KEYS {
    HAS_ACCEPTED_COOKIE = 'hasAcceptedCookie'
};